var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.833 7V4.5a.833.833 0 0 1 .834-.833h10a.833.833 0 0 1 .833.833v11.667a.833.833 0 0 1-.833.833h-2.5v2.5c0 .46-.375.833-.84.833H5.34A.835.835 0 0 1 4.5 19.5l.003-11.667c0-.46.375-.833.839-.833h2.491ZM6.17 8.667l-.002 10H14.5v-10H6.17ZM9.5 7h6.667v8.333h1.666v-10H9.5V7Z",
    fill: "#959799"
  })));
};
export default SvgCopy;